export default __webpack_public_path__ + "static/media/no-ads-icon.0c58fa1b.svg";